import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../..';
import {getIsFeatureEnabled} from '../../infrastructure';
import {FeatureToggle} from '../../data/entities/features';
import {removeParkingSpot} from './actions';
import {getAllParkingReservations} from './selectors';

// Note: this is in its own file because the indexed import of FeatureToggle somehow breaks the app
//      when it ends up in the timeslots slice...
export const ensureNoParkingSpotOnDate = createAsyncThunk<void, string, AppThunkApiConfig>(
  'parkingReservations/removeParkingSpotOnDate',
  async (dateKey, {getState, dispatch}) => {
    if (getIsFeatureEnabled(getState(), FeatureToggle.Parking)) {
      const reservation = getAllParkingReservations(getState()).find((r) => r.date.startsWith(dateKey));

      if (reservation) {
        await dispatch(removeParkingSpot(reservation.id)).unwrap();
      }
    }
  },
);
